import React, { useState, useEffect } from "react";
import App from "../../App";
import Navbar from "../../components/Navbar";
import SideBar from "../../components/SideBar";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PublicRoute from "../../routes/PublicRoute";
import Login from "../../modules/login/login";
import OfferAcceptOrReject from "../../modules/external/offer-accept-reject";
import ExternalRoute from "../../routes/ExtenalRoute";
import ForgotPassword from "../../components/ForgotPassword";
import ResetPassword from "../../components/ResetPassword";
import CandidateDetails from "../../modules/external/candidate-details/CandidateDetails";
import ThankYouPageCandidate from "../../modules/external/candidate-details/CandidateDetailsSubmitted";
import LinkExpired from "../../modules/external/candidate-details/LinkExpired";
import NavBar_Mobile from '../../components/NavBar_Mobile';
import { getActivePaths } from "../../components/NavBarMenu/navigationUtils";
import { BuildNavigation } from "../../components/NavBarMenu/navigationConfig";
// import Dashboard from "../../modules/Dashboard/Dashboard";
import ThankYou from "../../modules/external/thankyou";
import { color } from "framer-motion";
// import Footer from "../../components/Footer";
import { actionsArray } from "../../components/NavBarMenu/navigationConfig";
import { customMappings } from "../../components/NavBarMenu/navigationConfig";
 
const Layout = () => {
  const heading = useSelector(
    ({ layoutReducer
    }) => layoutReducer
      ?.filterSlice?.navbarHeading
  );
 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeMenu,setActiveMenu]=useState([])
  const isAuthenticated = useSelector((state) => state?.auth?.authentication);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);
 
  if (location.pathname != '/login' && isAuthenticated == undefined && !localStorage.getItem('logout')) {
    localStorage.setItem('pathname', location.pathname);
  }
  setTimeout(() => {
    localStorage.removeItem('logout');
  }, 2000);

const formatBasePathToName = (basePath) => {
  if (!basePath || basePath === '/') return 'Dashboard';

  const segments = basePath.split('/').filter(Boolean);
  const mainSegment = segments[segments.length - 1];

  if (!mainSegment) return 'Dashboard';

  // Check custom mappings (assuming customMappings is available in scope)
  const mappingKey = mainSegment.toLowerCase();
  if (typeof customMappings !== 'undefined' && customMappings[mainSegment]) return customMappings[mainSegment];
  if (typeof customMappings !== 'undefined' && customMappings[mappingKey]) return customMappings[mappingKey];

  return mainSegment
    .replace(/-|_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  };

  function getPathHierarchy(menuItems, currentUrl) {
    // 1. Handle Hardcoded Overrides (Priority)
    if (currentUrl.includes("50881180195049806954114046419509")) return ["Human Resource", "Birthday Details"];
    if (currentUrl.includes("current-job-opening")) return ["Job Openings"];
    if (currentUrl.includes("knowledge-sharing")) return ['Organization', 'Knowledge Sharing'];
    if (currentUrl.includes("employee-profile")) return ['Employee Profile | Nice Software Solutions Pvt. Ltd.'];
    if (currentUrl.includes("employee/history/edit")) return ["RMG", "Employee Manager", "Practice/reporting Manager"];
    if (currentUrl.includes("my-appraisal-components")) return ["Payroll", "Appraisal 2026-27"];

    // 2. Recursive Search Function
    function findPathInMenu(items, targetPath) {
      for (const item of items) {
        // Direct match
        if (item.path === targetPath) {
          return [item.name];
        }
        // Check sub-routes
        if (item.subRoutes && item.subRoutes.length > 0) {
          const childPath = findPathInMenu(item.subRoutes, targetPath);
          if (childPath) {
            return [item.name, ...childPath];
          }
        }
      }
      return null;
    }

    // 3. Progressive Path Matching
    // Example: /allocate-task/add -> try /allocate-task/add -> then try /allocate-task
    let urlParts = currentUrl.split('/').filter(Boolean);
    
    while (urlParts.length > 0) {
      const tryPath = '/' + urlParts.join('/');
      const foundHierarchy = findPathInMenu(menuItems, tryPath);
      
      if (foundHierarchy) {
        return foundHierarchy;
      }
      // Pop the last segment and try again (climbing up the tree)
      urlParts.pop();
    }

    // 4. Fallback to Action Array or Formatting
    if (typeof actionsArray !== 'undefined' && actionsArray.length > 0) {
      const matchingActions = actionsArray
        .filter(action => action === "/" ? currentUrl === "/" : currentUrl.startsWith(action))
        .sort((a, b) => b.length - a.length);

      if (matchingActions[0]) {
        const prettyName = formatBasePathToName(matchingActions[0]);
        return prettyName === "Dashboard" ? ["Dashboard"] : [prettyName];
      }
    }

    // Default Fallback
    return ["Dashboard"];
  }

  const relatedPath = getPathHierarchy(activeMenu, location.pathname);
 
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  };
 
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);
 
const specialSentences = [
  'RMG',
  'Raise IT Ticket',
  'Apply ML/BL/PL', 
  'My TDS Certificate',
  'Employee CTC Report',
  'Approve ML/BL/PL',
  'HR Attendance Approval',
  'Incentive & CCA',
  'Inc. & CCA Approval',
  'Inc. & CCA',
  'Inc. & CCA Statement',
];

function capitalizeEachWord(sentence) {
    if (!sentence || typeof sentence !== 'string') {
        return sentence || '';
    }

    if (specialSentences.includes(sentence)) {
      return sentence;
    }

    return sentence
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
  return (
    <>
      {
        isMobile ?
          <>
            <>
              <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<PublicRoute />}>
                  <Route path="/login" element={<Login />} />
                </Route>
 
                <Route
                  path="/50881180195049806954114046419505/:offer_id"
                  element={<ExternalRoute />}
                >
                  <Route
                    path="/50881180195049806954114046419505/:offer_id"
                    element={<OfferAcceptOrReject />}
                  />
                </Route>
 
                <Route path="/forgot-password" element={<PublicRoute />}>
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                </Route>
 
                <Route path="/reset-password/:token" element={<PublicRoute />}>
                  <Route path="/reset-password/:token" element={<ResetPassword />} />
                </Route>
 
                <Route path="/offer-accepted" element={<ExternalRoute />}>
                  <Route path="/offer-accepted" element={<ThankYou />} />
                </Route>
 
                {/* Candidate Details form */}
                <Route
                  path="/candidate-details/:candidate_id"
                  element={<ExternalRoute />}
                >
                  <Route
                    path="/candidate-details/:candidate_id"
                    element={<CandidateDetails />}
                  />
                </Route>
 
                <Route path="/link-expired" element={<ExternalRoute />}>
                  <Route path="/link-expired" element={<LinkExpired />} />
                </Route>
 
                <Route path="/details-submitted" element={<ExternalRoute />}>
                  <Route
                    path="/details-submitted"
                    element={<ThankYouPageCandidate />}
                  />
                </Route>
 
                <Route
                  path="*"
                  element={
                    isAuthenticated ? (
                      <div className="nest-page">
                        <div className="main-container">
                          <SideBar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} /></div>
                        <div className="main-content-page">
                          <div className="Nav">
                            <NavBar_Mobile heading={heading || "...."} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
                          </div>
                          <App isSidebarOpen={isSidebarOpen} />
                          {/* <Footer /> */}
                        </div>
                      </div>
                    ) : (
                      <Navigate to="/login" state={{ from: location }} replace />
                    )
                  }
                />
              </Routes>
 
              <ToastContainer
                autoClose={3000}
                draggable={false}
                position="top-right"
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnHover
              />
            </>
 
          </>
          :
          <>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<PublicRoute />}>
                <Route path="/login" element={<Login />} />
              </Route>
 
              <Route
                path="/50881180195049806954114046419505/:offer_id"
                element={<ExternalRoute />}
              >
                <Route
                  path="/50881180195049806954114046419505/:offer_id"
                  element={<OfferAcceptOrReject />}
                />
              </Route>
 
              <Route path="/forgot-password" element={<PublicRoute />}>
                <Route path="/forgot-password" element={<ForgotPassword />} />
              </Route>
 
              <Route path="/reset-password/:token" element={<PublicRoute />}>
                <Route path="/reset-password/:token" element={<ResetPassword />} />
              </Route>
 
              <Route path="/offer-accepted" element={<ExternalRoute />}>
                <Route path="/offer-accepted" element={<ThankYou />} />
              </Route>
 
              {/* Candidate Details form */}
              <Route
                path="/candidate-details/:candidate_id"
                element={<ExternalRoute />}
              >
                <Route
                  path="/candidate-details/:candidate_id"
                  element={<CandidateDetails />}
                />
              </Route>
 
              <Route path="/link-expired" element={<ExternalRoute />}>
                <Route path="/link-expired" element={<LinkExpired />} />
              </Route>
 
              <Route path="/details-submitted" element={<ExternalRoute />}>
                <Route
                  path="/details-submitted"
                  element={<ThankYouPageCandidate />}
                />
              </Route>
 
              <Route
                path="*"
                element={
                  isAuthenticated ? (
                    <div className="nest-page">
                      {/* <div className="main-container">
                  <SideBar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
                </div> */}
                      <div className="main-content-page">
                        <div className="Nav">
                          <Navbar heading={heading || "...."} isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} isMobile={isMobile} setActiveMenu={setActiveMenu}/>
                        </div>
                        {/* <div
                          className="container-fluid mt-2 pl-5 heading-wrapper"
                          style={{ marginBottom: "-4px", fontSize: "16px", pointerEvents: "none" }}
                        >
                          <strong className="heading-wrapper">{heading}</strong>
                        </div> */}
                        <div
                          className="container-fluid mt-2 pl-5 heading-wrapper"
                          style={{fontSize: "14px" }}
                        >
                          <span className="heading-wrapper">
                            {relatedPath?.map((item, index) => {
                              const isLast = index === relatedPath?.length - 1;
                              return (
                                <span key={index}>
                                  {isLast ? (
                                    <strong style={{color: "#27568B"}}>{capitalizeEachWord(item)}</strong>
                                  ) : (
                                    <strong style={{color: "#27568B", opacity: "80%"}}> {capitalizeEachWord(item)} </strong>
                                  )}
                                  {/* Add separator if not the last item */}
                                  <strong style={{color: "#27568B"}}>{!isLast && <span>&nbsp;&nbsp;&raquo;&nbsp;&nbsp;</span>}</strong>
                                </span>
                              );
                            })}
                          </span>
                        </div>
                       
                        <App isSidebarOpen={isSidebarOpen} />
                        {/* <Footer /> */}
                      </div>
                    </div>
                  ) : (
                    <Navigate to="/login" state={{ from: location }} replace />
                  )
                }
              />
            </Routes>
 
            <ToastContainer
              autoClose={3000}
              draggable={false}
              position="top-right"
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnHover
            />
          </>
      }
    </>
  );
};
 
export default Layout;